// @flow
import queryString from 'query-string';
import { get } from 'lodash';

import { APP_DIRECTORY_PAGES_MOUNT_POINT } from 'web-ssr/app/common/constants';

import type { AppActionDropdownItem } from '@zapier/design-system-app-profiles';

export const createAppsPageLink = (url: string) =>
  `/${APP_DIRECTORY_PAGES_MOUNT_POINT}/${url}`;

export const createAppOverviewPageLink = (appSlug: string) =>
  createAppsPageLink(`${appSlug}`);

export const createAppIntegrationsPageLink = (appSlug: string) =>
  createAppsPageLink(`${appSlug}/integrations`);

export const createAppAlternativesPageLink = (appSlug: string) =>
  createAppsPageLink(`${appSlug}/alternatives`);

export const createAppHelpPageLink = (appSlug: string) =>
  createAppsPageLink(`${appSlug}/help`);

export const createAppTutorialsPageLink = (appSlug: string) =>
  createAppsPageLink(`${appSlug}/tutorials`);

export const createAppTutorialDetailsLink = (
  appSlug: string,
  tutorialSlug: string
) => createAppsPageLink(`${appSlug}/tutorials/${tutorialSlug}`);

export const createTwoAppPageLink = (
  primaryAppSlug: string,
  secondaryAppSlug: string
) => createAppsPageLink(`${primaryAppSlug}/integrations/${secondaryAppSlug}`);

export const createZapTemplatePageLink = (
  primaryServiceSlug: string,
  secondaryServiceSlug: string,
  zapId: string,
  zapSlug: string
) =>
  `${createTwoAppPageLink(
    primaryServiceSlug,
    secondaryServiceSlug
  )}/${zapId}/${zapSlug}`;

export const buildMakeAZapLink = (
  selectedTrigger: AppActionDropdownItem,
  selectedAction: AppActionDropdownItem
) => {
  const qs = queryString.stringify({
    template__0__selected_api: get(selectedTrigger, ['appId']),
    template__0__type_of: get(selectedTrigger, ['typeOf']),
    template__0__action: get(selectedTrigger, ['value']),
    template__1__selected_api: get(selectedAction, ['appId']),
    template__1__type_of: get(selectedAction, ['typeOf']),
    template__1__action: get(selectedAction, ['value']),
    create: true,
  });

  return `/app/editor/?${qs}`;
};
